import { render } from "./App.vue?vue&type=template&id=1c4861e2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1c4861e2&lang=css"
script.render = render

export default script